function parseMetric (metricId) {
  const profileMatch = metricId ? metricId.match(/profile_(\d+)_(.+)/) : null;
  const goalMatch = metricId ? metricId.match(/goal_(\d+)_(.+)/) : null;

  /*
   * custom metric name is not consistent it may be `custommetric_123` or `custom_metric_123` (depends on instrument)
   * so this is why there are 2 regexes
   */
  const cmMatch = metricId ? metricId.match(/custommetric_(\d+)/) : null;
  const cmSnakeCaseMatch = metricId ? metricId.match(/custom_metric_(\d+)/) : null;

  if (profileMatch) {
    return {
      profileId: JSON.parse(profileMatch[1]),
      goalId: null,
      cmId: null,
      simpleMetricId: profileMatch[2]
    };
  }
  if (goalMatch) {
    return {
      profileId: null,
      goalId: JSON.parse(goalMatch[1]),
      cmId: null,
      simpleMetricId: goalMatch[2]
    };
  }
  if (cmMatch) {
    return {
      profileId: null,
      goalId: null,
      cmId: JSON.parse(cmMatch[1]),
      simpleMetricId: metricId
    };
  }
  if (cmSnakeCaseMatch) {
    return {
      profileId: null,
      goalId: null,
      cmId: JSON.parse(cmSnakeCaseMatch[1]),
      simpleMetricId: 'custom_metric'
    };
  }
  return {
    profileId: null,
    goalId: null,
    cmId: null,
    simpleMetricId: metricId
  };
}

export default parseMetric;
